<template>
  <BaseModal @close="closeModal">
    <div class="unsaved-changes-container">
      <h2 class="unsaved-changes-container__title">
        {{ $t('leavingPageModal.UNSAVED_CHANGES') }}
      </h2>

      <div class="unsaved-changes-container__action-buttons">
        <BaseButton outline size="large" @click="closeModal()">
          {{ $t('leavingPageModal.STAY_PAGE') }}
        </BaseButton>
        <BaseButton theme="red" size="large" @click="next()">
          {{ $t('leavingPageModal.DISCARD_CHANGES') }}
        </BaseButton>
      </div>
    </div>
  </BaseModal>
</template>

<script>
/**
 * @deprecated - use DialogModal component instead
 */
import BaseModal from '@/components/generics/base/BaseModal.vue'
import BaseButton from './base/BaseButton.vue'

export default {
  components: {
    BaseButton,
    BaseModal,
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
    closeModal: {
      type: Function,
      required: true,
    },
  },
  emits: ['onCloseModal', 'onDiscardChanges'],
}
</script>

<style lang="scss" scoped>
.unsaved-changes-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $spacing-2xs;
  padding: $spacing-xl;

  &__title {
    @include subtitle;
  }

  &__action-buttons {
    @include form-action-buttons-layout;
    justify-content: center;
    margin: $spacing-xs $spacing-xs 0 $spacing-xs;
  }
}
</style>
